import React from "react";
import { observer } from "mobx-react";
import { PaymentReceiptViewStore } from "../../store";
import { PaymentReceiptViewForm } from "./PaymentReceiptViewForm";
import { ErrorDialog } from "../../../../common/controls";
import { DownloadIcon } from "../../../../icons";
import { VisibilityIcon } from "../../../../icons";
import { isOriginalCrudStatus, RowCrudStatus } from "../../../common/types";
import { useRootStore } from "../../../../store/contexts";
import { PDFViewerDialog } from "../../../../common/components/PDFViewerDialog";

export type PaymentReceiptViewProps = {
  paymentReceiptViewStore: PaymentReceiptViewStore;
};

export const PaymentReceiptView: React.FC<PaymentReceiptViewProps> = observer(
  ({ paymentReceiptViewStore }) => {
    const { langStore } = useRootStore();

    const getViewAction = (
      onDownload: (props: {
        id: string;
        type: string;
        name: string;
        __status__: RowCrudStatus;
      }) => void,
      onViewPdf?: (props: any) => void
    ) => {
      const actions: any[] = [];
      if (onViewPdf) {
        actions.push({
          columnName: "__action_view_pdf",
          onClick: (props: any) =>
            isOriginalCrudStatus(props.__status__) ? onViewPdf(props) : {},
          icon: <VisibilityIcon />,
          label: langStore.viewCommand,
          isActionEnabled: (props: any) =>
            props.name?.toLowerCase().endsWith(".pdf"),
        });
      }
      actions.push({
        columnName: "__action_view",
        onClick: (props: any) =>
          isOriginalCrudStatus(props.__status__) ? onDownload(props) : {},
        icon: <DownloadIcon />,
        label: langStore.downloadCommand,
      });
      return actions;
    };

    return (
      <div>
        <PaymentReceiptViewForm
          paymentReceiptFiles={paymentReceiptViewStore.paymentReceiptFiles}
          crc={paymentReceiptViewStore.crcValue}
          typeValue={paymentReceiptViewStore.typeValue}
          amount={paymentReceiptViewStore.amountValue}
          issueDateTime={paymentReceiptViewStore.issueDateTimeValue}
          statusOptions={paymentReceiptViewStore.getStatusOptions()}
          status={paymentReceiptViewStore.statusValue}
          totalUses={paymentReceiptViewStore.totalUsesValue}
          remainingUses={paymentReceiptViewStore.remainingUsesValue}
          usedDate={paymentReceiptViewStore.usedDateValue}
          signedEditionValue={paymentReceiptViewStore.signedEditionValue}
          usesVisibleColumns={paymentReceiptViewStore.usesVisibleColumns}
          usesSetColumnWiths={(x) =>
            paymentReceiptViewStore.usesSetColumnWiths(x)
          }
          usesRows={paymentReceiptViewStore.usesRowsDyn}
          onPrint={(handlePrint: () => void) =>
            paymentReceiptViewStore.printPaymentReceipt(handlePrint)
          }
          onCancel={() => paymentReceiptViewStore.cancelPaymentReceipt()}
          onEdit={
            paymentReceiptViewStore.isEditEnabled
              ? () => paymentReceiptViewStore.editPaymentReceipt()
              : undefined
          }
          paymentReceiptViewAction={getViewAction(
            (props) =>
              paymentReceiptViewStore.fileDownload(props, "paymentReceipt"),
            (props) =>
              paymentReceiptViewStore.viewFilePdf(props, "paymentReceipt")
          )}
        />
        <ErrorDialog
          open={paymentReceiptViewStore.errorDialogOpened}
          title={paymentReceiptViewStore.errorTitle}
          description={paymentReceiptViewStore.errorDescription}
          onClose={() => paymentReceiptViewStore.closeErrorDialog()}
        />
        <PDFViewerDialog
          open={paymentReceiptViewStore.pdfViewerOpen}
          onClose={() => paymentReceiptViewStore.closePdfViewer()}
          pdfUrl={paymentReceiptViewStore.pdfViewerUrl}
          title={paymentReceiptViewStore.pdfViewerTitle}
        />
      </div>
    );
  }
);
